<template>
  <ApplyForm v-if="is_ok != 'ja'"
      :webid = webid
      :themeBase = themeBase
      :captcha = captcha
      @postFile="postFile"
      @postForm="postForm"
   />
  <br>
  <div v-if="is_ok == 'nein'"><b>Bitte kontrollieren Sie Ihre Eingabe beim Captcha.</b></div>
  <div v-if="is_ok == 'ja'"><b>Vielen Dank!</b><br>Wir kontaktieren Sie bald möglichst!</div>

</template>

<script>

import axios from "axios"
import ApplyForm from "@/components/apply_form";

const appElement = document.getElementById('wp_data')
const appSettings = JSON.parse(appElement.getAttribute('data-settings'))

export default {
  name: 'App',
  data() {
    return {
      apiBase: appSettings.apiBase,
      mediaBase: appSettings.mediaBase,
      themeBase: appSettings.themeBase,
      webid: appSettings.webID,
      captcha: appSettings.captcha,
      is_ok : 'neu',
      appSettings: appSettings,
      onUpload: null
    }
  },
  components: {
    ApplyForm
  },
  methods: {
    postForm(formdata) {
      axios.get(this.themeBase + '/ajax/cap_check.php?val='+formdata.captcha+'&chiff='+this.captcha).then(
          (response) => {
             if (response.data == 'yes') {
               axios.post(this.apiBase + '/avd3/v1/post_bewerbung/', formdata).then(() => {
                 this.is_ok = 'ja'
                 // eslint-disable-next-line
                 window.adf&&adf.ClickTrack(this,2748995,'Abschicken Bewerbungsformular',{});
                 console.log("Bewerbung111")
               })
             } else {
               this.is_ok = 'nein'
             }
          }
      )
    },
    postFile(event) {
      const formData = new FormData()
      formData.append("file", event.target.files[0])
      formData.append("id", event.target.attributes.name.value)
      formData.append("filename", event.target.files[0].name)
      formData.append("author", this.user_id)

      console.log(event.target.attributes.id)

      let headers = {};
      headers['Content-Disposition'] = 'form-data; filename=\'' + event.target.files[0].name + '\'';
      axios.post(this.apiBase + '/avd3/v1/post_file/', formData, headers).then(() => {
        console.log("posted File")
        this.onUpload = {
          "acf_fc_layout": "medieninhalt",
          "medieninhalt": {
            "mediendatei": event.target.files[0].name,
            "beschreibung": "NEW"
          }
        }
      })
    },
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
</style>
